import {createBrowserRouter} from 'react-router-dom'
import Auth from '../Layout/Auth'
import Main from '../Layout/Main'
import Appointment from '../Pages/Appointment/Appointment'
import Home from '../Pages/Home/Home'
import Login from '../Pages/Login/Login'
import Register from '../Pages/Register/Register'

export const router = createBrowserRouter([
{
    path:'/',
    element:<Main></Main>,
    children:[
       {
        path:'/',
        element:<Home></Home>
       },
       {
        path:'/appointment',
        element:<Appointment></Appointment>
       }

    ]
},
{
    path:'/',
    element:<Auth></Auth>,
    children:[
       {
        path:'/login',
        element:<Login></Login>
       },
       {
        path:'/register',
        element:<Register></Register>
       }

    ]
}
])